export default __webpack_public_path__ + "static/media/product-04 (1).42c2af02.jpg";